import styled from "styled-components";

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;
